import { useCallback, useEffect, useState } from 'react';
/**
 * Consistent loader for "fetch a list and expose reload()". Every list screen
 * uses this so the loading/error/reload triplet is identical, and the shape
 * plugs directly into AntD Table's `loading` prop.
 */
export function useLoader(fetcher, deps) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const reload = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            setData(await fetcher());
        }
        catch (err) {
            setError(err.message || 'שגיאה');
        }
        finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    useEffect(() => { void reload(); }, [reload]);
    return { data, loading, error, reload };
}
